import { useCallback, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { unwrapResult } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import { Breadcrumb } from "../../../components/Breadcrumbs/breadcrumbs"

import CustomInput from "../../../uiKit/Input/CustomInput";
import CustomButton from "../../../uiKit/Button/CustomButton";
import { InputFile } from "../../../uiKit/Input/InputFile";
import CustomSelect from "../../../uiKit/CustomSelect/CustomSelect";

import { getCommunity, getTypes, setImageURL, updateCommunity } from "../../../redux/state/communitySlice";

const EditCommunity = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { communityId } = useParams();

    const community = useSelector(state => state.community.community, shallowEqual);
    const types = useSelector(state => state.community.types, shallowEqual);
    const imageURL = useSelector(state => state.community.communityImageURL, shallowEqual);
    const isLoading = useSelector(state => state.community.isLoading.common, shallowEqual);
    const isLoadingTypes = useSelector(state => state.community.isLoading.getTypes, shallowEqual);
    const screenWidth = useSelector(state => state.common.screenWidth, shallowEqual);

    const [file, setFile] = useState(null);
    const [backgroundImage, setBackgroundImage] = useState(null)
    const [uploaded, setUploaded] = useState(false);
    const [description, setDescription] = useState('');
    const [note, setNote] = useState('');

    useEffect(() => {
        if (!types) {
            dispatch(getTypes())
        }

        if (!!types) {
            const isDefault = types.some(item => item.desktopImage === imageURL || item.mobileImage === imageURL);
            setUploaded(isDefault);
        }
    }, [types, imageURL, dispatch])

    useEffect(() => {
        if (!communityId) return;
        dispatch(getCommunity(communityId))
            .then(unwrapResult)
            .then(response => {
                const { community } = response;
                const { images, description, note } = community;
                setDescription(description);
                setNote(note);
                if (screenWidth < 900) {
                    dispatch(setImageURL(images.mobile));
                }
                else {
                    dispatch(setImageURL(images.desktop));
                }
            })
    }, [dispatch, screenWidth, communityId])

    const handleSubmit = useCallback(() => {
        if (!communityId) return;

        const { communityTypeId, name, location } = community;

        const data = {
            communityTypeId,
            name,
            location,
            file,
            description,
            note,
            communityId,
        }
        dispatch(updateCommunity(data))
            .then(unwrapResult)
            .then(() => {
                toast.info('Saved');
                history.goBack();
            })
            .catch(({ title }) => toast.info(title))
    }, [
        dispatch,
        file,
        history,
        note,
        description,
        community,
        communityId,
    ])

    const onDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    const onNoteChange = (e) => {
        setNote(e.target.value);
    }

    const handleCancel = () => history.goBack()

    return <>
        <Breadcrumb title={"Edit"} />
        <div className="editCommunityWrapper menuVersion">
            <div className="photoUpload"
                style={{
                    backgroundImage: `url(${!!backgroundImage ? backgroundImage : imageURL})`,
                    backgroundSize: "cover",
                    backgroundPosition: 'center',
                    objectFit: 'cover'
                }}>
                <InputFile
                    uploaded={uploaded}
                    setUploaded={setUploaded}
                    setBackgroundImage={setBackgroundImage}
                    setFile={setFile}
                />
            </div>
            <div className='inputWrapperEditCommunity'>
                <CustomInput
                    label="Name of community"
                    value={community.name}
                    disabled={true}
                />
                <div className="inputRow">
                    <CustomSelect
                        label="Community Type"
                        placeholder="Choose community type"
                        data={types}
                        value={community.communityTypeId}
                        loading={isLoadingTypes}
                        disabled={true}
                    />
                    <CustomInput
                        label="Location"
                        value={community.location}
                        disabled={true}
                    />
                </div>
                <CustomInput
                    multiline
                    label="Description"
                    onChange={onDescriptionChange}
                    value={description}
                    maxLength={250}
                />
                <CustomInput
                    multiline
                    label='Note'
                    onChange={onNoteChange}
                    maxLength={2000}
                    value={note}
                    description={"Notes will be only visible for admins"}
                    style={{ marginBottom: '16px' }}
                />
            </div>
            <div style={{
                width: '100%',
                display: 'flex',
                gap: 18,
            }}>
                <CustomButton
                    onClick={handleSubmit}
                    title='Save'
                    disabled={isLoading}
                    loading={isLoading}
                />
                <CustomButton
                    isWhite
                    onClick={handleCancel}
                    title='Cancel'
                    disabled={isLoading}
                    loading={isLoading}
                />
            </div>
        </div>
    </>
}

export default EditCommunity;